// For cosmetic purposes only. The email is already available in the FE state of the app.
export function maskEmail(email) {
  const [username, domain] = email.split("@");
  const maskedUsername = `${username.slice(0, 2)}${"*".repeat(3)}`;
  const maskedDomain = `${domain[0]}${"*".repeat(3)}`;
  const extension = domain.slice(domain.lastIndexOf("."));
  return `${maskedUsername}@${maskedDomain}${extension}`;
}
